import { Model } from 'survey-core';
import { SELF_SERVE_VALUE } from '../components/questionTypes/MuiAdditionalProducts';

export const getPurchaseInfo = (survey: Model, transactionId: string) => {
  const getProductValue = (productId: string, variableName: string) =>
    survey.runExpression(`expandChoicesByUrl('${productId}', '${variableName}')`);

  const calculateDiscount = (productId: string) => {
    const price = getProductValue(productId, 'price');
    const discountedPrice = survey.runExpression(`getPriceWithDiscount('${productId}')`);
    return Number((price - discountedPrice).toFixed(2));
  };

  const { subscriptionSelect, additionalProducts, discountCode } = survey.data;
  const operationType = survey.getVariable('info')?.operationType || '';
  const items = [];
  const joiningFeeId = survey.runExpression("getJoiningFee('id')");
  const tax = Number(
    (
      survey.getVariable('subscriptionTotalPrice').replace(/[^\d.]/g, '') -
      survey.getVariable('totalWithDiscountAmount')
    ).toFixed(2)
  );

  if (joiningFeeId) {
    items.push({
      item_id: joiningFeeId,
      item_name: getProductValue(joiningFeeId, 'subscriptionTier'),
      discount: calculateDiscount(joiningFeeId),
      price: survey.runExpression(`getPriceWithDiscount('${joiningFeeId}')`),
      quantity: 1
    });
  }

  if (subscriptionSelect) {
    items.push({
      item_id: subscriptionSelect,
      item_name: getProductValue(subscriptionSelect, 'subscriptionTier'),
      discount: calculateDiscount(subscriptionSelect),
      price: survey.runExpression(`getPriceWithDiscount('${subscriptionSelect}')`),
      quantity: 1
    });
  }

  if (additionalProducts && additionalProducts !== SELF_SERVE_VALUE) {
    items.push({
      item_id: additionalProducts,
      item_name: getProductValue(additionalProducts, 'purchaseType'),
      discount: calculateDiscount(additionalProducts),
      price: survey.runExpression(`getPriceWithDiscount('${additionalProducts}')`),
      quantity: 1
    });
  }

  return {
    event: 'purchase',
    ecommerce: {
      purchase_type: operationType,
      nrw_status: operationType,
      transaction_id: transactionId,
      value: survey.getVariable('totalWithDiscountAmount'),
      tax,
      shipping: 0,
      currency: getProductValue(subscriptionSelect, 'currencyIso'),
      coupon: survey.getVariable('discount') ? discountCode : undefined,
      items
    }
  };
};
